module.exports = __webpack_public_path__ + "img/logo_angel@2x.b400fd3e.png";